import React, { useMemo, memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import DynamicFieldView from '../DynamicFieldView';
import { useSelector } from 'react-redux';
import { getDynamicFieldView } from '../store/selectors/getDynamicFieldView';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import dynamicFieldViewReducer from '../store/reducers/dynamicFieldView';
import buildFieldViewStream from '../utils/buildFieldViewStream';
import ErrorBoundaryWrapper from '../../ErrorFallback/ErrorBoundaryWrapper';

initContainerData.register({
    reducers: {
        dynamicFieldView: dynamicFieldViewReducer
    }
});

const DynamicFieldViewDataContainer = ({
    renderStandalone,
    id
}) => {
    const { venueId, venueName, syncingThresholds, gamePk } = useSelector(getDynamicFieldView);

    const fieldViewStream = useMemo(() => {
        if (venueId) {
            return buildFieldViewStream({ venueId, useDVR: false, gamePk });
        }
    }, [venueId, gamePk]);

    return (
        <ErrorBoundaryWrapper componentName={'Field movement'}>
            {fieldViewStream && (
                <DynamicFieldView
                    fieldViewStream={fieldViewStream}
                    syncingThresholds={syncingThresholds}
                    venueName={venueName}
                    venueId={venueId}
                    renderStandalone={renderStandalone}
                />
            )}
        </ErrorBoundaryWrapper>
    );
};

DynamicFieldViewDataContainer.propTypes = {
    error: PropTypes.object,
    id: PropTypes.string,
    renderStandalone: PropTypes.bool,
    gamePk: PropTypes.string
};

export default memo(DynamicFieldViewDataContainer);
